<template>
  <div class="Row" ref="root">
    <div
      id="HpProductList"
      class="ProductList relative grid auto-rows-fr md:auto-rows-auto md:flex md:flex-wrap mb-10"
      style="min-height: 500px; width: 100%"
      ref="list"
      v-auto-animate="{ duration: 300 }"
    >
      <div
        v-if="isEmpty"
        class="Product -OnHoverBordered Col relative w-full md:w-1/2 xl:w-9/12"
        key="0"
        data-size="3 / 4"
      >
        <div
          class="text-h2 flex gap-2 p-5 border-4 border-solid border-divider-dark rounded-2xl h-full justify-center items-center"
        >
          {{ $t('Zadaným filtrům nevyhovuje žádný kurz') }}
        </div>
      </div>

      <template v-for="voucher in list" :key="voucher.id">
        <!-- Pozor jina sablona, jiny vnitrek, neni to fotka pres cely element -->
        <a
          v-if="voucher.stickyByNavigation && voucher.card_bg_color"
          class="Product -AmbiCard Col [ flex flex-col relative ]"
          :class="voucher.class"
          :href="voucher.link"
          :key="voucher.id + 'b'"
          :data-size="voucher.size"
          :style="{ width: voucher._width }"
        >
          <div
            class="ProductOverlay absolute inset-0 mx-4 rounded-ambi"
            :style="{
              backgroundColor: voucher.card_bg_color
            }"
          ></div>

          <div class="relative h-full flex flex-col">
            <div class="ProductCategory text-p2 inline-flex items-center gap-x-1 static px-3 pt-5">
              <span
                v-for="category in voucher.categories"
                :key="category.icon"
                :title="category.name"
                class="FilterTag -Card"
              >
                {{ category.name }}
              </span>
            </div>

            <div class="flex flex-1 p-1 absolute inset-0">
              <aw-img
                class="m-auto"
                src="/assets/temp/karty.png"
                :image="voucher.image"
                :size="voucher.image_folder"
                style="width: 250px"
              />
            </div>

            <div
              class="ProductName"
              :style="{ color: voucher.card_text_color, right: '1rem', left: '1rem' }"
            >
              <div class="text-h2 mb-2" v-html="voucher.name"></div>
              <div class="text-p1">{{ $t('Uplatnitelná všude') }}</div>
            </div>
          </div>
        </a>
        <!-- produkty -->
        <a
          v-else
          class="Product -OnHoverBordered Col relative"
          :class="voucher.class"
          :href="voucher.link"
          :key="voucher.id + 'a'"
          :data-size="voucher.size"
          :style="{ width: voucher._width }"
        >
          <div
            class="ProductInner rounded-image"
            :style="{ backgroundImage: 'url(' + voucher.image_url + ')' }"
            style="
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            "
          >
            <picture>
              <source :srcset="voucher.image_url" media="(min-width: 1279px)" />
              <img :src="voucher.image_mobile_url" class="rounded-image lg:invisible" alt="" />
            </picture>
            <div class="ProductOverlay -Gradient absolute inset-0 mx-4 rounded-ambi"></div>
            <div class="ProductData">
              <!--               
              <div class="bg-orange-100 absolute right-0 top-0 text-xs w-64">
                ID: {{ voucher.id }} <br />
                NAME: {{ voucher.name }} <br />
                FIX PRICE: {{ voucher?.price }} <br />
                MIN: {{ voucher?.min_price }} <br />
                MAX: {{ voucher?.max_price }} <br />
              </div> -->

              <div class="ProductCategory text-p2 inline-flex items-center gap-x-1">
                <span
                  v-for="category in voucher.categories"
                  :key="category.icon"
                  :title="category.name"
                  class="FilterTag -Card"
                >
                  {{ category.name }}
                </span>
              </div>
              <div class="ProductName" :style="{ color: voucher.card_text_color }">
                <div class="text-h2 mb-2" v-html="voucher.name"></div>
                <div class="text-p1" v-if="voucher.stickyByNavigation">
                  {{ $t('Uplatnitelná všude') }}
                </div>
                <div class="text-p1" v-else-if="voucher.price">
                  {{ $t('Cena') }} {{ voucher.price.price_formatted }}
                </div>
                <div class="text-p1" v-else-if="voucher.min_price">
                  {{ $t('Cena od') }} {{ voucher.min_price.price_formatted }}
                </div>
              </div>
            </div>
          </div>
        </a>
      </template>
    </div>
  </div>
  <a
    href="#"
    class="Btn -Secondary -Large flex w-full justify-center gap-0.5"
    @click.stop.prevent="updateList(true)"
    v-if="stack.length > 0"
  >
    {{ $t('Načíst další') }}
    <aw-icon icon="chevron-down" class="w-7 h-7" />
  </a>
</template>

<script>
import imageSizeUrl from 'nette-media-module/js/utils/imageSizeUrl'
import shuffle from 'lodash/shuffle'
import intersection from 'lodash/intersection'
import useAmbiFilter from './AmbiFilters/AmbiFilter'
//import { onBeforeRouteUpdate } from 'vue-router'
import { mapGtmItemsFromProducts, trackViewItemList } from '../gtm'

const scrollToAnchor = function () {
  const hpList = document.getElementById('nostickyFilters')
  const products = document.querySelector('.Products')

  if (hpList) {
    let offset = window.innerWidth < 600 ? 80 : 50
    window.scrollTo({
      behavior: 'smooth',
      top: products.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
    })
    /* products.scrollIntoView()*/
  }
}

const sizes = {
  '3/4': {
    class: 'w-full md:w-1/2 xl:w-9/12',
    image_folder: '1384x500x8',
    image_folder_mobile: '710x850x8',
    image: 'size34__image',
    image_mobile: 'size14__image',
    nominal_image: 'size14__image',
    nominal_image_folder: '440x440x8'
  },
  '1/2': {
    class: 'w-full md:w-1/2 xl:w-6/12',
    image_folder: '915x500x8',
    image_folder_mobile: '710x850x8',
    image: 'size12__image',
    image_mobile: 'size14__image',
    nominal_image: 'size14__image',
    nominal_image_folder: '440x440x8'
  },
  '1/4': {
    class: 'w-full md:w-1/2 xl:w-3/12',
    image_folder: '440x500x8',
    image_folder_mobile: '710x850x8',
    image: 'size14__image',
    image_mobile: 'size14__image',
    nominal_image: 'size14__image',
    nominal_image_folder: '440x440x8'
  }
}

export default {
  props: {
    vouchers: Array,
    allowNotShowWoFilter: {
      type: Boolean,
      default: true
    },
    stickyVoucher: {
      type: Object
    }
  },
  data() {
    return {
      stack: [],
      list: [],
      post: 0,
      rowFill: 0,
      prevRowStartWithSize: '3/4',
      isMounted: false,
      calculatedWidths: {},
      isEmpty: false
    }
  },
  setup() {
    const {
      areSelectedFiltersEqualDefaults,
      selectedFilters,
      applyReduceSortFilters,
      watchUrlChanges
      //resetFilters
    } = useAmbiFilter()

    watchUrlChanges()

    return {
      areSelectedFiltersEqualDefaults,
      selectedFilters,
      applyReduceSortFilters
    }
  },

  computed: {
    computedVouchers() {
      return [...this.vouchers].map(card => {
        card.stickyByNavigation = false

        if (card.id === this.stickyVoucher?.id) {
          card.stickyByNavigation = true
          card.card_bg_color = this.stickyVoucher.card_bg_color
          card.card_text_color = this.stickyVoucher.card_text_color
        }
        return card
      })
    },

    vouchersLength() {
      return this.list.length
    },

    filterListNotShowWoFilterRule() {
      let filters = []

      // rule over rule ;)
      if (!this.allowNotShowWoFilter) {
        return filters
      }

      this.computedVouchers.forEach(card => {
        card.categories.forEach(category => {
          if (category.not_show_wo_filter && !filters.includes(category.id)) {
            filters.push(category.id)
          }
        })
      })

      return filters
    }
  },
  methods: {
    calculateCardsWidth() {
      if (!this.isMounted) {
        return
      }
      // eslint-disable-next-line no-extra-semi
      ;[...this.$refs.list.children].forEach(card => {
        //console.log(card.offsetWidth, card.clientWidth, card.getBoundingClientRect().width)
        this.calculatedWidths[card.getAttribute('data-size')] =
          card.getBoundingClientRect().width + 'px'
      })
    },

    updateList(all = false) {
      const list = []
      let rows = 0

      while (this.stack.length > 0) {
        // reset row fill
        if (this.rowFill === 4) {
          this.rowFill = 0
        }

        if (this.rowFill === 0) {
          rows++
        }

        if (all == false) {
          if (rows === 4) {
            break
          }
        }

        ++this.pos

        if (this.pos === 1 && this.stack.length === 1) {
          const card = { ...(this.stackFindNoAmbiCard(this.stack) || this.stack.splice(0, 1))[0] }
          card.size = '1/4'
          ++this.rowFill
          list.push(this.decorateCard(card))
          continue
        }

        // na prvni pozici davame vzdy 3/4 kartu
        if (this.pos === 1 && this.stack.length > 1) {
          const card = { ...(this.stackFindNoAmbiCard(this.stack) || this.stack.splice(0, 1))[0] }
          card.size = '3/4'
          this.rowFill = 3
          list.push(this.decorateCard(card))
          continue
        }

        // na druhou pozici davame vzdy 1/4 ambi kartu
        if (this.pos === 2) {
          const card = { ...(this.stackFindAmbiCard(this.stack) || this.stack.splice(0, 1))[0] }
          card.size = '1/4'
          ++this.rowFill
          list.push(this.decorateCard(card))
          continue
        }

        // radek nikdy nezaciname stejnou velikosti karty jako radek predchozi
        if (this.rowFill === 0) {
          const card = { ...this.stack.splice(0, 1)[0] }
          const startRowSizes = []
          if (this.prevRowStartWithSize === '3/4') {
            startRowSizes.push('1/4', '1/2')
          } else if (this.prevRowStartWithSize === '1/2') {
            startRowSizes.push('1/4', '3/4')
          } else {
            startRowSizes.push('1/2', '3/4')
          }

          this.prevRowStartWithSize = card.size = startRowSizes.includes(card.default_size)
            ? card.default_size
            : shuffle(startRowSizes)[0]
          this.rowFill = this.sizeToRowFill(card.size)
          list.push(this.decorateCard(card))
          continue
        }

        // pokud je radek zaplneny z poloviny, nebudeme k nemu davat dalsi pulku
        if (this.rowFill === 2) {
          const card = { ...(this.stackFindSize(this.stack, '1/4') || this.stack.splice(0, 1))[0] }
          card.size = '1/4'
          this.rowFill += this.sizeToRowFill(card.size)
          list.push(this.decorateCard(card))
          continue
        }

        const card = {
          ...(this.stackFindSize(this.stack, this.rowFillToSize(4 - this.rowFill)) ||
            this.stack.splice(0, 1))[0]
        }
        card.size = this.rowFillToSize(4 - this.rowFill)
        this.rowFill += this.sizeToRowFill(card.size)
        list.push(this.decorateCard(card))
      }

      let productListName = 'Home'

      if (this.$route.fullPath.includes('kurzy')) {
        productListName = 'Workshops'
      }

      trackViewItemList(mapGtmItemsFromProducts(list, productListName), productListName)

      this.list = this.list.concat(list)
    },
    stackFindNoAmbiCard(stack) {
      for (let i = 0; i < stack.length; i++) {
        const card = stack[i]
        if (!card.stickyByNavigation) {
          return stack.splice(i, 1)
        }
      }

      return null // no ambi card exist?
    },
    stackFindAmbiCard(stack) {
      for (let i = 0; i < stack.length; i++) {
        const card = stack[i]

        if (
          card.stickyByNavigation /*card.type === this.ambiStackingCardConfig.type && card.sticky_card*/
        ) {
          return stack.splice(i, 1)
        }
      }

      return null // no not ambi card exists in stack?
    },
    stackFindSize(stack, size) {
      for (let i = 0; i < stack.length; i++) {
        const card = stack[i]
        if (card.default_size === size) {
          return stack.splice(i, 1)
        }
      }

      return null // no card in size found
    },
    sizeToRowFill(size) {
      if (size === '3/4') {
        return 3
      }

      if (size === '1/2') {
        return 2
      }

      return 1
    },
    rowFillToSize(rowFill) {
      if (rowFill === 1) {
        return '1/4'
      }
      if (rowFill === 3) {
        return '3/4'
      }
      return '1/2'
    },
    decorateCard(card) {
      card.class = sizes[card.size].class
      card._width = sizes[card.size]._width

      if (card.stickyByNavigation /* === this.ambiStackingCardConfig.type && card.sticky_card*/) {
        card.image = card[sizes[card.size].nominal_image]
        card.image_folder = sizes[card.size].nominal_image_folder
        card.image_mobile = card[sizes[card.size].nominal_image]
        card.image_mobile_folder = sizes[card.size].nominal_image_folder
      } else {
        card.image = card[sizes[card.size].image]
        card.image_folder = sizes[card.size].image_folder
        card.image_mobile = card[sizes[card.size].image_mobile]
        card.image_mobile_folder = sizes[card.size].image_folder_mobile
      }

      card.image_url = imageSizeUrl(card.image, card.image_folder)
      card.image_mobile_url = imageSizeUrl(card.image_mobile, card.image_mobile_folder)

      if (Object.keys(this.calculatedWidths).length !== 0) {
        card._width = this.calculatedWidths[card.size]
      }

      return card
    }
  },
  watch: {
    selectedFilters: {
      handler(newVal) {
        const noFilterUsed = this.areSelectedFiltersEqualDefaults

        if (newVal) {
          if (typeof newVal === 'object') {
            this.calculateCardsWidth()

            //  1) shuffle, tak zobrazime vse, filtry se na to nevztahuji
            if (newVal.shuffle) {
              this.stack = shuffle([...this.computedVouchers])
            } else {
              // zadny filtr nebyl aplikovany
              if (noFilterUsed) {
                this.stack = [...this.computedVouchers]
                /*
                  nic neni vybrane, proto musime navic vyradit veci ktere do vychozi stavu nepujdou
                  tj. maji priznak 'not_show_wo_filter=1'
                */
                this.stack = this.stack.filter(card => {
                  const intersectionDiff = intersection(
                    card.categories.map(card => card.id),
                    this.filterListNotShowWoFilterRule
                  )

                  return intersectionDiff.length === 0 || card.stickyByNavigation
                })
              } else {
                // byly aplikovane jakekoliv filtry
                const filteredVoucher = this.applyReduceSortFilters(this.computedVouchers)
                this.stack = [...filteredVoucher]
              }
            }
          }
        }

        this.list = []
        this.pos = 0
        this.rowFill = 0
        this.prevRowStartWithSize = '3/4'
        this.isEmpty = this.stack.length === 0

        // add sticky card to stack
        if (!this.stackFindAmbiCard([...this.stack])) {
          const stickyCard = this.stackFindAmbiCard([...this.computedVouchers])
          if (stickyCard) {
            this.stack.push(stickyCard[0])
          }
        }

        this.updateList()

        if (!noFilterUsed) {
          this.$nextTick(() => {
            // scroll nahoru jen na mobilnich zarizenich
            if (
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
              ) ||
              window.scrollY === 0
            ) {
              scrollToAnchor()
            } else {
              // bohuzel i sem, protoze to skace diky hasmarku nekdy ..ach jo, podminku nahore nechavam, protoze se to bude hodit, jeste s tim asi budeme pracovat
              //scrollToAnchor()
            }
          })
        }
      },
      immediate: true,
      deep: true // newVal is object now! ref([])
    }
  },
  mounted() {
    this.isMounted = true
    /* vymazat sirky*/
    window.addEventListener(
      'resize',
      () => {
        this.calculatedWidths = {}
        // eslint-disable-next-line no-extra-semi
        ;[...this.$refs.list.children].forEach(card => {
          card.style.cssText = null
        })
      },
      false
    )
  }
}
</script>

<style lang="scss" scoped>
.Overlay {
  transition: 200ms ease-in-out;
  @apply invisible inset-0;
  top: -6px;
  z-index: -1;
}

.ProductList.-LoadingState .Overlay {
  @apply visible;
  z-index: 8;
}

.list-enter-active {
  transition: opacity 300ms ease;
}
.list-enter-from {
  opacity: 0;
}

.ProductList > a {
  /* height: 500px;
  overflow: hidden; */
}

.Product {
  height: auto;

  @screen lg {
    height: 500px;
  }
}
</style>
